import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import activity from './module/activity'; // 应用中心
import Address from "./module/Address";
import brand from './module/brand'; // 品牌保护
import commodity from './module/commodity'; // 商品
import Content from './module/Content';
import dataAnalysis from './module/dataAnalysis'; // 新商品管理修改
import detect from './module/detect'; // 价格检测
import FcnctionSerrings from './module/FcnctionSerrings'; // 商家入驻
import loginModule from './module/loginModule'; // 登入相关
import message from "./module/message";
import newshop from './module/newshop'; // 新商品管理修改
import pressimApi from "./module/pressimApi";
import product from './module/product'; // 商家入驻
// import { startsWith } from 'core-js/fn/string'
const VuexLocal = new VuexPersistence({
    storage: window.localStorage
}); // https://github.com/championswimmer/vuex-persist vuex的本地持久化插件


const Modele = {
    loginModule,
    product,
    commodity,
    brand,
    activity,
    detect,
    newshop,
    dataAnalysis,
    Address,
    pressimApi,
    Content,
    message,
    FcnctionSerrings
}
Vue.use(Vuex) //Vue全局引用vuex 就
export default new Vuex.Store({
    // 全局变量 放在 state里面 
    state: {
        header: {}, //请求头
        tokenHeaders: '', //不同类型请求头
        userInfo: null, //用户信息
        login: false, // 登录状态
        isMenuColl: false, //菜单展开状态
        auth: '', //获取得整个token信息 包括过期时间 token等，后端定义
        rou: ['/data/overview'],
        titles: '',
        token: '',
        account_wx: '',
        account_ali: '',
        totalAmount: 0, // 总金额
        withdrawableCash: 0, // 可提现金额
        regist: {
            reviewer_status: '',
            phone: ''
        }, //审核未通过，参数
        pageSize: 5, //提现列表显示数量  
        unreadCount: 0,
        selDetailData: null,
        isAllinUser: 0,
        registerUrl: "",
        app_verify: [],
    },
    getters: {
        getAppVerify: state => {
            return state.app_verify;
        },
        getRegisterUrl: state => {
            return state.registerUrl;
        },
        getIsAllinUser: state => {
            return state.isAllinUser;
        },
        getSelDetailData: state => {
            return state.selDetailData;
        },
        getUnreadCount: state => {
            return state.getUnreadCount;
        },
        getPageSize: state => {
            return state.pageSize;
        },
        getRegist: state => {
            return state.regist;
        },
        getTotalAmount: state => {
            return state.totalAmount;
        },
        getWithdrawableCash: state => {
            return state.withdrawableCash;
        },
        getRouter: state => {
            return state.rou;
        },
        getAccountWx: state => {
            return state.account_wx;
        },
        getAccountAli: state => {
            return state.account_ali;
        },
        getTokenTime: state => {
            return state.tokenTime;
        },
        getAuth: state => {
            return state.auth;
        },
        getToken: state => {
            const token = state.token || localStorage.getItem('token');
            state.token = token;
            return state.token;
        },
        getUserInfo: state => {
            return state.userInfo
        },
        getIsMenuColl: state => {
            return state.isMenuColl
        },
        getLogin: state => {
            const login = JSON.parse(localStorage.getItem('login'));
            if (login) {
                state.login = login;
            }
            return state.login;
        },

    },
    mutations: {
        setAppVerify(state, data) {
            state.app_verify = data;
        },
        setRegisterUrl(state, data) {
            state.registerUrl = data;
        },
        setIsAllinUser(state, data) {
            state.isAllinUser = data;
        },
        setSelDetailData(state, data) {
            state.selDetailData = data;
        },
        setUnreadCount(state, data) {
            state.getUnreadCount = data;
        },
        setPageSize(state, data) {
            state.pageSize = data;
        },
        setRegist(state, data) {
            state.regist = data;
        },
        setTotalAmount(state, data) {
            state.totalAmount = data;
        },
        setWithdrawableCash(state, data) {
            state.withdrawableCash = data;
        },
        setTitles(state, data) {
            state.titles = data;
        },
        setAccountWx(state, data) {
            state.account_wx = data;
        },
        setAccountAli(state, data) {
            state.account_ali = data;
        },
        setRouters(state, data) {
            state.rou = data;
        },
        setToken(state, data) {
            if (data) {
                state.tokenHeaders = {
                    headers: {
                        Authorization: "Bearer " + data,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
                state.header = {
                    headers: {
                        Authorization: "Bearer " + data,
                        'Content-Type': 'application/json; charset=UTF-8;'
                    }
                };
            }
            state.token = data;
        },
        setAuth(state, data) {
            state.auth = data;
        },
        setLogin(state, data) {
            state.login = data;
        },
        setTokenTime(state, data) {
            state.tokenTime = data;
        },
        setUserInfo(state, data) {
            state.userInfo = data;
        },
        setIsMenuColl(state, data) {
            state.isMenuColl = data;
        },
    },
    // actions不能直接修改全局变量，需要调用commit方法来触发mutation中的方法
    actions: {

    },
    modules: {
        //用来分多个文件
        ...Modele,
    },
    plugins: [VuexLocal.plugin]
})